import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "popup__content" }
const _hoisted_3 = { class: "form-group mb-3" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "text-danger d-block mb-2"
}
const _hoisted_7 = { class: "d-flex justify-content-end gap-2 flex-nowrap" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "text-danger d-block"
}
const _hoisted_14 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropzoneInput = _resolveComponent("DropzoneInput")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-primary btn-sm text-capitalize-first",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
        }, _toDisplayString(_ctx.actionLabel), 1),
        (!_ctx.bootstrapModal)
          ? (_openBlock(), _createBlock(_component_Popup, {
              key: 0,
              ref: "linkPopup",
              class: "popup--narrow",
              title: _ctx.$t('labels.manual_sbp_qr_deal_image'),
              onOnClose: _ctx.hidePopup
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.link) = $event)),
                      type: "text",
                      class: "form-control mb-3",
                      autocomplete: "off",
                      placeholder: _ctx.$t('labels.manual_sbp_qr_deal_link_placeholder')
                    }, null, 8, _hoisted_4), [
                      [_vModelText, _ctx.link]
                    ]),
                    _createVNode(_component_DropzoneInput, {
                      options: _ctx.dropzoneOptions,
                      label: "labels.qr_upload_file",
                      onChange: _ctx.onImageChange,
                      onReject: _ctx.onImageReject
                    }, null, 8, ["options", "onChange", "onReject"]),
                    (_ctx.previewUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.previewUrl,
                          alt: "",
                          class: "manual-sbp-qr-preview mt-3"
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    (_ctx.previewUrl)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-link btn-sm px-0 mt-1",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.$t('button.delete')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.localError)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.localError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-dark btn-sm text-nowrap",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('button.cancel')), 1)
                    ]),
                    _createVNode(_component_LoaderButton, {
                      "on-click": _ctx.save,
                      class: "btn btn-primary btn-sm text-nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('button.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["on-click"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title", "onOnClose"]))
          : (_openBlock(), _createBlock(_component_BModal, {
              key: 1,
              "model-value": _ctx.bsOpen,
              title: _ctx.$t('labels.manual_sbp_qr_deal_image'),
              "footer-class": "d-flex justify-content-end gap-2 flex-nowrap",
              "onUpdate:modelValue": _ctx.onBsOpenChange
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.link) = $event)),
                    type: "text",
                    class: "form-control mb-3",
                    autocomplete: "off",
                    placeholder: _ctx.$t('labels.manual_sbp_qr_deal_link_placeholder')
                  }, null, 8, _hoisted_11), [
                    [_vModelText, _ctx.link]
                  ]),
                  _createVNode(_component_DropzoneInput, {
                    options: _ctx.dropzoneOptions,
                    label: "labels.qr_upload_file",
                    onChange: _ctx.onImageChange,
                    onReject: _ctx.onImageReject
                  }, null, 8, ["options", "onChange", "onReject"]),
                  (_ctx.previewUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.previewUrl,
                        alt: "",
                        class: "manual-sbp-qr-preview mt-3"
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.previewUrl)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-link btn-sm px-0 mt-1",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["prevent"]))
                      }, _toDisplayString(_ctx.$t('button.delete')), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.localError)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.localError), 1))
                  : _createCommentVNode("", true)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary btn-sm text-nowrap text-capitalize-first",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.$t('button.cancel')), 1),
                _createVNode(_component_LoaderButton, {
                  "on-click": _ctx.save,
                  class: "btn btn-primary btn-sm text-nowrap"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('button.save')), 1)
                  ]),
                  _: 1
                }, 8, ["on-click"])
              ]),
              _: 1
            }, 8, ["model-value", "title", "onUpdate:modelValue"]))
      ]))
    : _createCommentVNode("", true)
}